// Csupasz kategória-URL (pl. cikk-útvonalról levágott szegmens) → a terület-oldal
// kategória-horgonyára irányítunk (a kategóriának nincs önálló oldala — spec 6.1).
import { createFileRoute, redirect } from '@tanstack/react-router';

import { requireAuth } from '@/lib/auth';

export const Route = createFileRoute('/hub/$spaceSlug/$categorySlug/')({
  beforeLoad: async ({ location, params }) => {
    await requireAuth(location.href);
     
    throw redirect({
      to: '/hub/$spaceSlug',
      params: { spaceSlug: params.spaceSlug },
      hash: params.categorySlug,
      replace: true,
    });
  },
});
